import React, { JSX, useState } from "react";
import { Outlet } from "react-router";
import { ApplicationSearchContext } from "utilities/contexts/search/aen-applications/application-search-context";
import {
    ApplicationSearchCriteria,
    defaultApplicationSearchCriteria,
} from "utilities/contexts/search/aen-applications/application-search-context";
import { useGlobalState } from "utilities/contexts/use-global-state-context";

interface AenApplicationLayoutProps {}

const AenApplicationLayout: React.FC<AenApplicationLayoutProps> = (): JSX.Element => {

    const { record: globalState } = useGlobalState();
    const currentUserId = globalState.currentIdentity?.userId() ?? undefined;

    const [applicationSearchCriteria, setApplicationSearchCriteria] = useState<ApplicationSearchCriteria>(
        defaultApplicationSearchCriteria(currentUserId)
    );

    console.log("AenApplicationLayout rendered with criteria:", applicationSearchCriteria);
    return (
        <ApplicationSearchContext.Provider
            value={{ currentUserId: currentUserId, initialCriteria: applicationSearchCriteria, setCriteria: setApplicationSearchCriteria }}>
            <Outlet />
        </ApplicationSearchContext.Provider>
    );
};

export { AenApplicationLayout };
